<template>
  <div>
    <SubMenuHeader
      :title="$t('burgerMenu.profile')"
      @onGoBack="onGoBack"
      @showVideo="$emit('showVideo')"
    />
    <div>
      <ProfileDetails/>
    </div>
  </div>
</template>

<script>
import SubMenuHeader from '../../SubMenuHeader';
import ProfileDetails from "@/components/hamburgerMenu/components/ProfileDetails.vue";

export default {
  'name': 'Profile',
  'components': { ProfileDetails, SubMenuHeader },
  'methods': {
    onGoBack() {
      this.$router.back();
    }
  }
}
</script>
